<template>
  <v-dialog
    content-class="dialog-custom"
    v-model="dialog"
    persistent
    width="700px"
  >
    <v-card light>
        <div style="position: absolute; right: 0; padding-top: 10px">
          <v-btn class="mx-2" icon title="Close Form" @click="handleDialogClose">
            <v-icon class="material-icons-round"> close </v-icon>
          </v-btn>
        </div>
      <v-card-title>
        <PlanSelectionNew
            :isCreatePortfolio ="false"
            :isEditPortfolio="true"
            :currentPortfolio="selectedPortfolio"
            @portfolio="portfolioHandler"
            @success="handleStep"
        />
      </v-card-title>
    </v-card>
  </v-dialog>
</template>

<script>
import PlanSelectionNew from '@/components/lenderOnboarding/planSelectionNew'
export default {
    name: 'editProfileDialog',
    components: {
        PlanSelectionNew
    },
    props: {
        showPlanDialog: Boolean,
        selectedPortfolio: Object
    },
    data () {
        return {
            dialog: this.showPlanDialog
        }
    },
    methods: {
        handleDialogClose () {
            this.$emit('closeDialog')
        },
        portfolioHandler (data) {
            this.$store.commit('portfolio/setPortfolio', data)
            this.selectedPortfolio = data
        },
        handleStep () {
            this.$emit('closeDialog')
        }
    }
}
</script>
<style lang="scss" scoped>
.v-card__title {
  line-height: 24px;
  word-break: normal;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.dialog-custom {
  height: 120px !important;
  background: #ffffff;
  border: 1px solid #b9b9bb !important;
  box-sizing: border-box !important;
  border-radius: 21px !important;

}

.v-text-field .v-label {
  font-weight: bold !important;
}
.dialog-header-custom {
  width: 200px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
}

.custom-btn-common {
  width: 150px;
  font-size: 14px;
  text-transform: none;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 22px;
}

::v-deep .v-dialog > .v-card > .v-card__title {
    padding-left: 0px !important;
    padding-right: 0px !important;
    padding-top: 40px !important;
    padding-bottom: 40px !important;
}

</style>
